
import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as Forward } from '../../../assets/icons/forward.svg';
import { ReactComponent as Animation } from '../../../assets/icons/intro/scanning.svg';
import PrimaryButton from '../../../components/buttons/primarybutton/PrimaryButton';
import Header from '../../../components/header/Header';
import H2 from '../../../components/text/H2';
import { tag } from '../../../services/ATInternetService';


const Scanning = ({ onNextSlideRequested }) => {
	return <section className="intro__slide--start">
		<Header className="fixed top-0" />
		<div className="overflow-y-auto overflow-x-hidden w-screen pt-12 px-4">
			<div className="bg-white bg-opacity-10 rounded-3xl m-auto max-w-4xl px-4 pt-4">
				<Animation className="intro__animation" />
				<H2 className="py-6 text-center">
					Als je iets goed wilt scannen, neem dan voldoende afstand!
					<br />Vanaf ongeveer 1 meter is goed.
				</H2>
				<PrimaryButton
					className="mb-4"
					onClick={() => {
						onNextSlideRequested('scanning');
						tag.sendClick('intro', {
							chapter3: 'scanning',
							name: 'next-slide',
						});
					}}>
					<Forward />
				</PrimaryButton>
			</div>
		</div>
	</section>;
}

Scanning.propTypes = {
	onNextSlideRequested: PropTypes.func.isRequired
}

export default Scanning
